export default __webpack_public_path__ + "static/media/logo.349e3d74.svg";